import React, { useEffect, useState } from "react";
import { useGet, useGetSimple } from "../../services/GetService";
import PreviewEdit from "../preview/PreviewEdit";
import { useParams } from "react-router-dom";
import Acordion from "../acordion/Acordion";

const Edit = ({ setShowLoading }) => {
    const [replyTo, setReplyTo] = useState(0);

    useEffect(() => {
        setShowLoading(false);
    }, []);
    const { slug } = useParams();

    const [form, setForm] = useGetSimple(slug);
    useEffect(() => {
        setDataInput(form.form_input);
    }, [form]);

    const [inputs, setInputs] = useGet("inputs");
    const [companies, setCompanies] = useGet("companies");
    const [dataInput, setDataInput] = useState([]);
    const [dataSelect, setDataSelect] = useState([]);
    const [editableInput, setEditableInput] = useState(false);
    const [itemEditable, setItemEditable] = useState([]);

    return (
        dataInput !== undefined && (
            <div id="create-form">
                <div className="container-fluid">
                    <div className="col-12">
                        <div className="row form">
                            <div className="col-4">
                                <Acordion
                                    inputs={inputs}
                                    companies={companies}
                                    dataInput={dataInput}
                                    setDataInput={setDataInput}
                                    dataSelect={dataSelect}
                                    setDataSelect={setDataSelect}
                                    editableInput={editableInput}
                                    setEditableInput={setEditableInput}
                                    itemEditable={itemEditable}
                                    setItemEditable={setItemEditable}
                                    form={form}
                                    setForm={setForm}
                                    edit={true}
                                    replyTo={replyTo}
                                    setReplyTo={setReplyTo}
                                    slug={slug}
                                />
                            </div>
                            <div className="col-8 mt-3">
                                <PreviewEdit
                                    dataInput={dataInput}
                                    dataSelect={dataSelect}
                                    editableInput={editableInput}
                                    setEditableInput={setEditableInput}
                                    setItemEditable={setItemEditable}
                                    replyTo={replyTo}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default Edit;
